import { Routes, Route } from 'react-router-dom';
import Login from '../components/login/login';

const GenericPages = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Login />} />
    </Routes>
  );
};
export default GenericPages;
    